import React, { useState, useMemo } from 'react';
import '../../assets/scss/stripe.scss';
import {
  useStripe,
  useElements,
  FpxBankElement,
} from '@stripe/react-stripe-js';
import CheckoutError from './CheckoutError';
import stripeSecImg from 'assets/img/stripe-badge-white.svg';
import { Button } from 'reactstrap';
import { setProcessingPayment } from '../../_actions/global.action';
import { useDispatch } from 'react-redux';

const useOptions = () => {
  const options = useMemo(
    () => ({
      accountHolderType: 'individual',
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [],
  );

  return options;
};

const FXBankStripeCheckoutForm = ({ price, intent }) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const [isProcessing, setProcessingTo] = useState(false);
  const dispatch = useDispatch();

  const [checkoutError, setCheckoutError] = useState();
  const [value, setValue] = useState(null);

  const handleSubmit = async (ev) => {
    // Block native form submission.
    ev.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.

    setProcessingTo(true);
    dispatch(setProcessingPayment(true));
    console.log(intent);
    try {
      const paymentMethodReq = await stripe.createPaymentMethod({
        type: 'fpx',
        fpx: elements.getElement(FpxBankElement),
      });

      console.log(paymentMethodReq.paymentMethod);
      if (paymentMethodReq.error) {
        setCheckoutError(paymentMethodReq.error.message);
        setProcessingTo(false);
        dispatch(setProcessingPayment(false));
        return;
      }

      const confirmedCardPayment = await stripe.confirmFpxPayment(
        intent.client_secret,
        {
          payment_method: paymentMethodReq.paymentMethod.id,
          return_url: `${window.location.href}`,
        },
      );

      if (confirmedCardPayment.error) {
        setCheckoutError(confirmedCardPayment.error.message);
        setProcessingTo(false);
        dispatch(setProcessingPayment(false));
        return;
      }
    } catch (err) {
      setCheckoutError(err.message);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="stripe_payment">
        <label>
          FPX Bank
          <FpxBankElement
            className="FpxBankElement"
            options={options}
            onChange={(event) => {
              console.log('FpxBankElement [change]', event);
              setValue(event.value);
            }}
          />
        </label>
        {checkoutError && <CheckoutError>{checkoutError}</CheckoutError>}
        <Button
          color="primary"
          block
          type="submit"
          className="mb-4 mt-4 btn_apply"
          disabled={!stripe || isProcessing || !value}
        >
          {isProcessing ? 'Processing...' : `Pay ${price}`}
        </Button>
      </form>
      <div className="d-flex justify-content-center flex-column align-items-center">
        <img
          src={stripeSecImg}
          alt="Stripe - Trust badge"
          title="Stripe - Trust badge"
          style={{ width: '332px', margin: 0 }}
        />
      </div>
    </>
  );
};

export default FXBankStripeCheckoutForm;
